import React, { useContext, useMemo } from 'react';
import classes from './ReportContent.module.scss';
import { Button, Descriptions, Divider } from 'antd';
import { ListPOItem } from '../../poItems';
import { InspectionContext } from 'app/modules/inspection/contexts';
import DateHelper from 'app/definitions/helpers/date';
import { Status } from 'app/modules/ui';
import withSwitchElement from 'app/modules/ui/components/hocs/switch-element';
import ESignModal from 'app/pages/ReportDetail/components/ESignModal';
import { RightOutlined } from '@ant-design/icons';

type ReportContentProps = {
  overallReportResult?: {
    text: string;
    color: string | any;
  };
};

const SignedView = ({ inspection }) => {
  const [viewSignature, setViewSignature] = React.useState(false);
  return (
    <span className={classes.signedView}>
      <span className={classes.signedLabel}>Signed</span>
      <Button
        className={classes.signedBtn}
        size="small"
        type="link"
        onClick={() => {
          setViewSignature(true);
        }}
      >
        View
        <RightOutlined style={{ fontSize: 10 }} />
      </Button>
      <ESignModal
        opened={viewSignature}
        signObj={inspection}
        onClose={() => {
          setViewSignature(false);
        }}
      />
    </span>
  );
};

const EsignContent = withSwitchElement({
  true: SignedView,
  false: <span>Not signed yet</span>
});

const ReportContent: React.FC<ReportContentProps> = ({
  overallReportResult
}) => {
  const { inspection, report } = useContext(InspectionContext);

  const assignTo = useMemo(() => {
    if (report && Array.isArray(report.assignTo)) {
      return (
        report.assignTo
          .map((item) => item)
          .filter((item) => !!item)
          .join(', ') || 'N/A'
      );
    }
    return '';
  }, [report]);

  const signed = useMemo(() => {
    return !!inspection?.eSignatureDocumentListId;
  }, [inspection]);

  return (
    <div className={classes.reportContent}>
      <div className={classes.reportContent__header}>
        <h3>Internal Inspection Report</h3>
        <Descriptions className={classes['report-content__description']}>
          <Descriptions.Item span={3} label="Issued By">
            {assignTo}
          </Descriptions.Item>
          <Descriptions.Item span={3} label="Overall Report Result">
            <Status
              type="text"
              value={overallReportResult?.text}
              color={overallReportResult?.color as string}
            ></Status>
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <Descriptions className={classes['report-content__description']}>
          <Descriptions.Item span={3} label="Submitted Date">
            {DateHelper.formatDate(report?.submittedDate)}
          </Descriptions.Item>
          <Descriptions.Item span={3} label="Inspection Date">
            {DateHelper.formatRangeDateByKeys(
              inspection,
              ['inspectionDate', 'inspectionEndDate'],
              {
                defaultEmpty: 'N/A'
              }
            )}
          </Descriptions.Item>
          <Descriptions.Item span={3} label="E-signature">
            {/* 2021-09-01 */}
            <EsignContent value={signed} inspection={inspection} />
          </Descriptions.Item>
        </Descriptions>
        <Divider />
      </div>
      <div className={classes.reportContent__content}>
        <h3>Report Detail:</h3>
        {inspection && <ListPOItem inspectionId={inspection.id} />}
      </div>
    </div>
  );
};

export default ReportContent;
